"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withJourneyLiveReload = void 0;
const withJourneyLiveReload = (nextConfig) => (Object.assign(Object.assign({}, nextConfig), { webpack: (config, props) => {
        const nodeModuleIndex = config.watchOptions.ignored.findIndex((p) => p.includes('node_modules'));
        // Ignore all node modules except ours.
        config.watchOptions.ignored[nodeModuleIndex] = /node_modules\/(?!journey-ui).*/;
        if (nextConfig.webpack) {
            config = nextConfig.webpack(config, props);
        }
        return config;
    } }));
exports.withJourneyLiveReload = withJourneyLiveReload;
